import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '../../core';

const modifiers = {
  active: () => ({
    styles: `
      border: solid 1px #333333;
    `,
  }),
};

export const CardOptionStyled = styled.label`
  width: 100%;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    font-size: ${rem(14)};
    font-family: 'PetcoCircularTT';
    text-align: center;
    text-decoration: none;
    width: 100%;
    height: 100%;
    border: solid 1px #c4cdd5;
    background-color: ${(props) => props.theme.background_color};
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: .4rem;
    cursor: pointer;
    ${applyStyleModifiers(modifiers)};
  }

  input:checked ~ span {
    border: solid 1px #333333;
  }
`;
